import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const EmergencyColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Family Contacts (Local)": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Relationship",
        dataIndex: "Relationship",
        key: "relationship",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phoneNumber",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Family Contacts (Distant)": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Relationship",
        dataIndex: "Relationship",
        key: "relationship",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Insurance Agents": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Company",
        dataIndex: "Company",
        key: "company",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",render: (record) => (record ? record : "N/A"),

      },
      actionColumn,
    ],
    "Utility Companies": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Account Number",
        dataIndex: "Account Number",
        key: "accountnumber",
      },
      actionColumn,
    ],
    "Local Emergency Management Office": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      actionColumn,
    ],
    "Evacuation Centers": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      actionColumn,
    ],
    "Pet Emergency Contacts/Shelters": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      actionColumn,
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
